export default function OfferBanner() {
  return (
    <>
      <div className="store">
        <div>
          <img
            src="https://www.beautybebo.com/pub/media/mega-menu/beeone.jpg"
            alt=""
            height="100%"
            width="100%"
          />
        </div>
        <div>
          <img
            src="https://www.beautybebo.com/pub/media/mega-menu/lotus.jpg"
            alt=""
            height="100%"
            width="100%"
          />
        </div>
      </div>
    </>
  );
}
